<template>
  <div class="px-10">
    <v-row
      v-if="loading"
      no-gutters
    >
      <v-col>
        <v-progress-circular
          indeterminate
          color="primary"
        />
      </v-col>
    </v-row>
    
    <div v-else>
      <v-card
        v-for="companyEmployee in companyEmployees"
        :key="companyEmployee.company_employee_uid"
        class="ma-4"
      >
        <v-card-title>{{ companyEmployee.company.name }}</v-card-title>
        <v-card-text>
          <v-row no-gutters> 
            <v-col cols="2"> 
              <span class="font-weight-bold">Business Registration No.</span>
            </v-col>
            <v-col cols="1">
              :
            </v-col>
            <v-col cols="9">
              <v-skeleton-loader
                v-if="loading"
                type="list-item"
                class="loading-bar"
              />  
              <span v-else>  {{ companyEmployee.company.registration_no && companyEmployee.company.old_registration_no ? companyEmployee.company.registration_no + ' (' + companyEmployee.company.old_registration_no + ')' : companyEmployee.company.registration_no ? companyEmployee.company.registration_no : companyEmployee.company.old_registration_no ? companyEmployee.company.old_registration_no : 'N/A' }}</span>
            </v-col>
          </v-row>
          
          <v-row no-gutters> 
            <v-col cols="2"> 
              <span class="font-weight-bold">TIN</span>
            </v-col>
            <v-col cols="1">
              :
            </v-col>
            <v-col cols="9">
              <v-skeleton-loader
                v-if="loading"
                type="list-item"
                class="loading-bar"
              />  
              <span v-else>  {{ companyEmployee.company.tin_number ? companyEmployee.company.tin_number : 'N/A' }}</span>
            </v-col>
          </v-row>
          
          <v-row no-gutters> 
            <v-col cols="2"> 
              <span class="font-weight-bold">SST Registration No.</span>
            </v-col>
            <v-col cols="1">
              :
            </v-col>
            <v-col cols="9">
              <v-skeleton-loader
                v-if="loading"
                type="list-item"
                class="loading-bar"
              />  
              <span v-else>  {{ companyEmployee.company.sst_registration_number ? companyEmployee.company.sst_registration_number : 'N/A' }}</span>
            </v-col>
          </v-row>
          
          <v-row no-gutters> 
            <v-col cols="2"> 
              <span class="font-weight-bold">Address</span>
            </v-col>
            <v-col cols="1">
              :
            </v-col>
            <v-col cols="9">
              <v-skeleton-loader
                v-if="loading"
                type="list-item"
                class="loading-bar"
              />  
              <span v-else>  {{ companyEmployee.company.address ? companyEmployee.company.address : 'N/A' }}</span>
            </v-col>
          </v-row>
          
          <v-row no-gutters> 
            <v-col cols="2"> 
              <span class="font-weight-bold">Invoice Email</span>
            </v-col>
            <v-col cols="1">
              :
            </v-col>
            <v-col cols="9">
              <v-skeleton-loader
                v-if="loading"
                type="list-item"
                class="loading-bar"
              />  
              <span v-else>  {{ companyEmployee.company.invoice_email ? companyEmployee.company.invoice_email : 'N/A' }}</span>
            </v-col>
          </v-row>
          
          <v-row no-gutters> 
            <v-col cols="2"> 
              <span class="font-weight-bold">Invoice Contact No.</span>
            </v-col>
            <v-col cols="1">
              :
            </v-col>
            <v-col cols="9">
              <v-skeleton-loader
                v-if="loading"
                type="list-item"
                class="loading-bar"
              />  
              <span v-else>  {{ companyEmployee.company.invoice_contact_number ? companyEmployee.company.invoice_contact_number : 'N/A' }}</span>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    props: {
      employeeUid: {
        type: String, 
        default: '',
      },
    },
    data () {
      return {
        loading: false,
        companyEmployees: [],
      }
    },
    computed: {
      ...mapState({ isCurrentUser: 'isMyProfile' }),
      isMyProfile () {
        return this.$store.state.isMyProfile
      },
    },
    watch: {
      employeeUid: {
        immediate: true,
        handler (value) {
          if (value) {
            this.loadData()
          }
        },
      },
    },
    methods: {
      loadData () {
        this.loading = true

        this.$api.employeeCompanies().listAllCompanies(this.employeeUid)
          .then(res => {
            this.companyEmployees = res.data

            this.loading = false
          })
      },
    },
  }
</script>
